import types from "./types";

export const setInitialPagination = ({ scope, total, limit }) => ({
  type: types.SET_INITIAL,
  payload: {
    total,
    limit,
  },
  meta: { scope },
});

export const nextPage = ({ scope } = { scope: "" }) => ({
  type: types.NEXT_PAGE,
  meta: { scope },
});

export const previousPage = ({ scope } = { scope: "" }) => ({
  type: types.PREVIOUS_PAGE,
  meta: { scope },
});

export const setPage = ({ scope, page } = { scope: "" }) => ({
  type: types.SET_PAGE,
  meta: { scope },
  payload: { page },
});

export const reset = ({ scope } = { scope: "" }) => ({
  type: types.RESET,
  meta: { scope },
});

export const togglePaginationLoading = ({ scope } = { scope: "" }, isLoading) => ({
  type: types.TOGGLE_LOADING,
  meta: { scope },
  payload: isLoading,
});
